import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class Address extends Component {
    render() {
        const { address } = this.props;

        return (
            <div className="address-view">
                <p><b>{`${address.firstname} ${address.lastname}`}</b></p>

                <p>{address.address1}</p>

                <p>{address.address2}</p>

                <p>{`${address.city}, ${address.state_name} - ${address.zipcode}`}</p>

                <p>{address.country_name}</p>

                <p>
                    <label>
                        <FormattedMessage id="phone" defaultMessage="Phone" />
                        : &nbsp;
                    </label>
                    {address.phone}
                </p>
            </div>
        );
    }
}

export default Address;



/** WEBPACK FOOTER **
 ** ./src/components/order/address.jsx
 **/